import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';
import { last, sortBy } from 'lodash';

import Textarea from '../../ui/textarea';
import Modal from '../../ui/modal';
import Textfield from '../../ui/text-field';

import validObj from '../../../helpers/validateObj';
import aaSave from '../../../helpers/afterActionSave';
import aaValidation from '../../../helpers/afterActionValidation';

import moment from 'moment';

class Notes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userAction: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.notes !== nextProps.notes) {
            const anchor = document
                .getElementById('listings-anchor')
                .getBoundingClientRect().top;
            window.scrollTo(0, anchor);
        }
    }

    handleSubmit = e => {
        if (this.props.userAction === 'addNotes') {
            this.props.createNote();
        } else {
            const formObj = validObj(e);
            formObj.id = formObj.reportId;
            switch (this.props.userAction) {
                case 'save':
                    formObj.deliverable = formObj.aadeliverable;
                    formObj.recommend = formObj.aaRecommend;
                    formObj.approverId = formObj.aaApproverId;
                    this.props.updateAfterAction(formObj);
                    break;
                case 'submit':
                    const notValid = aaValidation(e);
                    if (!notValid) {
                        formObj.deliverable = formObj.aadeliverable;
                        formObj.recommend = formObj.aaRecommend;
                        this.props.submitAfterAction(formObj);
                    } else {
                        this.props.setEventErrorMessage(notValid);
                        if (e.aaawareness !== true && e.aabehavior !== true) {
                            this.props.setFormFieldValidity(
                                'event.aaawareness',
                                false
                            );
                            this.props.setFormFieldValidity(
                                'event.aabehavior',
                                false
                            );
                        } else if (
                            e.aaawareness === true ||
                            e.aabehavior === true
                        ) {
                            this.props.setFormFieldValidity(
                                'event.aaawareness',
                                true
                            );
                            this.props.setFormFieldValidity(
                                'event.aabehavior',
                                true
                            );
                        }
                    }
                    break;
                case 'approve':
                    this.props.approveAfterAction(formObj);
                    break;
                case 'request':
                    this.props.requestInfoAfterAction(formObj);
                    break;
                default:
                    console.log(this.props.userAction);
            }
        }
    };

    handleSubmitFailed = e => {
        if (this.props.userAction === 'request') {
            const values = aaSave(e);
            this.props.requestInfoAfterAction(values);
        }

        if (this.props.userAction === 'addNotes') {
            this.props.createNote();
        } else if (this.props.userAction === 'save') {
            const values = aaSave(e);
            this.props.updateAfterAction(values);
        }
    };

    render() {
        let saveSubmit = false;
        let approveReject = false;

        let canAddNote = false;
        let userInfo = this.props.userInfo;
        const trustingUserId = userInfo.TrustingUser
            ? userInfo.TrustingUser.id
            : null;
        if (
            this.props.aaStatus === 'Incomplete' ||
            this.props.aaStatus === 'Pending' ||
            this.props.aaStatus === 'Unapproved'
        ) {
            canAddNote = true;
        }

        if (
            this.props.groupStatus.status === 'After Action Incomplete' ||
            this.props.groupStatus.status === 'After Action Pending'
        ) {
            if (
                this.props.afterActionUserID === this.props.userInfo.id ||
                this.props.afterActionUserID === trustingUserId
            ) {
                saveSubmit = true;
            }
        } else if (
            this.props.eventState.EventReport.status === 'Unapproved' &&
            this.props.groupStatus.status === 'After Action Review' &&
            this.props.tasks &&
            this.props.tasks.length > 0
        ) {
            const mostRecentTask = last(sortBy(this.props.tasks, 'id'));
            if (mostRecentTask.userId === this.props.userInfo.id) {
                if (mostRecentTask.action === 'Info') {
                    saveSubmit = true;
                } else {
                    approveReject = true;
                }
            }
        }

        return (
            <Form
                className="form"
                model="event"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">Notes</div>

                <Textarea
                    model="event.notesToAdd"
                    title="Comment"
                    disabled={!canAddNote}
                    maxLength={1000}
                />

                {saveSubmit || approveReject || canAddNote ? (
                    <Control.button
                        model="event.userActionTaken"
                        value="addNotes"
                        type="submit"
                        className="btn btn--secondary btn--save"
                        onClick={() => {
                            // this.setState({ userAction: 'addNotes' });
                            this.props.setEventUserAction('addNotes');
                        }}
                    >
                        Add
                    </Control.button>
                ) : null}

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                    disabled={!saveSubmit && !approveReject}
                />

                <div className="form__actions form__actions--global">
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--secondary btn--save"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.props.setEventUserAction('save');
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.props.setEventUserAction('submit');
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="approve"
                            onClick={() => {
                                this.props.setEventUserAction('approve');
                            }}
                        >
                            Approve
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Modal
                            title="Returned for Edit"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Returned for Edit
                            </div>
                            <Textfield
                                model="event.aaRequestComments"
                                title="Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                </div>

                <div className="listings">
                    {this.props.notes.map((item, index) => {
                        const listing = (
                            <div className="listings__entry" key={index}>
                                <div className="listings__user">{`${
                                    item.rank
                                } ${item.firstName} ${item.lastName}`}</div>
                                <div className="listings__date">
                                    {moment(item.createdAt).format(
                                        'MMMM D, YYYY h:mm:ss a'
                                    )}
                                </div>
                                <div className="listings__body">
                                    {item.comments}
                                </div>
                            </div>
                        );
                        return listing;
                    })}
                    <span id="listings-anchor" />
                </div>
            </Form>
        );
    }
}

export default Notes;



// WEBPACK FOOTER //
// ./src/components/event/after-action/notes.js